import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { Plus, Rocket, Globe, SlidersHorizontal, FolderOpen } from 'lucide-react';
import { Loader, EmptyState, ViewToggle, trackPointer, MediaPlaceholder } from './UI';
import { getValidUrl, hasCustomImage } from '../utils/Utils';

function ProjectsComponent({ projects, categorias, loading, onCreateProject, onJoinProject }) {
  const [selectedCategory, setSelectedCategory] = useState("Todas");
  const [viewMode, setViewMode] = useState("grid");

  const filteredProjects = !loading
    ? projects.filter(p => p.accepted && (selectedCategory === "Todas" || p.category === selectedCategory))
    : [];

  const truncate = (text, maxLength) =>
    text?.length > maxLength ? text.substring(0, maxLength) + '…' : text;

  return (
    <div className="dyd-page">
      <Container>
        <div className="dyd-page-head">
          <div>
            <span className="dyd-eyebrow">Proyectos</span>
            <h1 style={{ marginTop: 16, marginBottom: 10 }}>
              Iniciativas <span className="dyd-gradient-text">del club</span>
            </h1>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <button className="dyd-btn dyd-btn-primary" onClick={onCreateProject}>
              <Plus size={17} strokeWidth={2.4} />
              Crear proyecto
            </button>
            <button className="dyd-btn dyd-btn-ghost" onClick={onJoinProject}>
              Unirse a proyecto
            </button>
          </div>
        </div>

        <p className="dyd-lead" style={{ marginBottom: 28 }}>
          Aquí se reúnen todos los proyectos de nuestra comunidad. Explora y descubre el talento detrás de cada uno.
        </p>

        <div className="dyd-panel dyd-filters">
          <div className="dyd-field" style={{ flex: '1 1 260px', maxWidth: 340 }}>
            <label className="dyd-label" htmlFor="projectCategory">
              <SlidersHorizontal size={12} style={{ marginRight: 6, verticalAlign: '-1px' }} />
              Categoría
            </label>
            <select
              id="projectCategory"
              className="dyd-select"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="Todas">Todas las categorías</option>
              {categorias.map((cat, index) => <option key={index} value={cat}>{cat}</option>)}
            </select>
          </div>

          <ViewToggle value={viewMode} onChange={setViewMode} />
        </div>

        {loading ? (
          <Loader text="Cargando proyectos" />
        ) : filteredProjects.length === 0 ? (
          <EmptyState
            icon={FolderOpen}
            title="Aún no hay proyectos en esta categoría"
            hint="Sé el primero en publicar el tuyo."
          />
        ) : viewMode === "grid" ? (
          <div className="dyd-grid">
            {filteredProjects.map((project, index) => (
              <article
                key={project._id || index}
                className="dyd-card dyd-rise"
                style={{ '--i': index % 12, cursor: 'pointer' }}
                onMouseMove={trackPointer}
                onClick={() => (window.location.href = `/project/${project._id}`)}
              >
                <div className="dyd-card-media">
                  {hasCustomImage(project.projectImage) ? (
                    <img src={project.projectImage} alt={project.name} />
                  ) : (
                    <MediaPlaceholder name={project.name} variant="card" />
                  )}
                </div>

                <div className="dyd-card-body">
                  {project.category && <span className="dyd-chip">{project.category}</span>}
                  <h3 className="dyd-card-title">{project.name}</h3>
                  <p className="dyd-card-text">{truncate(project.description, 120)}</p>

                  <div className="dyd-card-actions">
                    <a className="dyd-btn dyd-btn-primary dyd-btn-block" href={`/project/${project._id}`}>
                      <Rocket size={16} />
                      Ver proyecto
                    </a>
                    {project.website && (
                      <a
                        className="dyd-btn dyd-btn-ghost dyd-btn-block"
                        href={getValidUrl(project.website)}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Globe size={16} />
                        Visitar sitio
                      </a>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="dyd-list">
            {filteredProjects.map((project, index) => (
              <div
                key={project._id || index}
                className="dyd-list-item dyd-rise"
                style={{ '--i': index % 12, cursor: 'pointer' }}
                onClick={() => (window.location.href = `/project/${project._id}`)}
              >
                <div className="dyd-list-media">
                  {hasCustomImage(project.projectImage) ? (
                    <img src={project.projectImage} alt={project.name} />
                  ) : (
                    <MediaPlaceholder name={project.name} variant="list" />
                  )}
                </div>

                <div className="dyd-list-body">
                  <h3 className="dyd-list-title">{project.name}</h3>
                  {project.category && <span className="dyd-chip">{project.category}</span>}
                  <p className="dyd-list-text">{truncate(project.description, 90)}</p>
                </div>

                <div className="dyd-list-actions">
                  <a className="dyd-btn dyd-btn-primary" href={`/project/${project._id}`}>
                    <Rocket size={16} />
                    Ver proyecto
                  </a>
                  {project.website && (
                    <a
                      className="dyd-btn dyd-btn-ghost"
                      href={getValidUrl(project.website)}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Globe size={16} />
                      Visitar sitio
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </Container>
    </div>
  );
}

export default ProjectsComponent;
